





































































import LineItemsForm from "@/components/repair-estimate/LineItemsForm.vue";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { handleError } from "@/lib/utility/handleError";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Clearance, IClearance } from "@/models/clearance.entity";
import { InvoiceLine } from "@/models/invoice-line.entity";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import InvoiceFormPreview from "../invoice/InvoiceFormPreview.vue";

@Component({
  components: {
    InvoiceFormPreview,
    LineItemsForm
  },
  filters: {}
})
export default class ClearanceDetail extends mixins(PartnerFallbackMixin, PermissionMixin, RulesMixin) {
  readonly RequestStatusEnum = RequestStatusEnum;

  @Prop()
  value!: IClearance;

  isUpdateChangesDialogActive = false;

  isSaveChangesLoading = false;

  valueCopy: IClearance | null = null;

  isValid = false;

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  beforeMount() {
    this.abortChanges();
  }

  @Watch("valueCopy.title", { deep: true })
  @Watch("valueCopy.lineItems", { deep: true })
  @Watch("valueCopy.repairStart")
  @Watch("valueCopy.repairEnd")
  onValueChange() {
    this.isUpdateChangesDialogActive = true;
  }

  abortChanges() {
    this.valueCopy = new Clearance(this.value);
    this.valueCopy.lineItems = this.value.lineItems.map(lineItem => new InvoiceLine(lineItem)) ?? [];

    this.$nextTick(() => {
      this.isUpdateChangesDialogActive = false;
    });
  }

  async saveChanges() {
    this.isSaveChangesLoading = true;
    await this.valueCopy
      ?.updatePartial({
        lineItems: this.valueCopy.lineItems.map(li => li.dto),
        title: this.valueCopy.title,
        repairStart: this.valueCopy.repairStart,
        repairEnd: this.valueCopy.repairEnd
      })
      .then(res => {
        this.isUpdateChangesDialogActive = false;
        this.value.map(res);
      })
      .catch(handleError);
    this.isSaveChangesLoading = false;
    this.isUpdateChangesDialogActive = false;
  }
}
